import React, { Fragment } from 'react';
import { bool, number, string, shape, arrayOf, object } from 'prop-types';
import AmpImg from 'components/AmpImg';
import AmpHtml from 'components/AmpHtml';
import AmpAccordion from 'components/AmpAccordion';
import AmpSideBySide from 'components/AmpSideBySide';
import AmpVideo from 'components/AmpVideo';
import styles from './styles';

// CLEANUP: Quick workaround to detect custom html Giphy embeds. These will hopefully
// be converted to a type (or image) in the future, however the Instant Pot FAQ
// includes LOT of Giphy embeds that are HUGE. This function is used to naively
// detect Giphy embeds so the HTML block can be lazy loaded.
function isGiphy(html) {
  return html.includes('giphy.com/embed');
}

function AmpFaq({ pos, title, items, isAffiliate, hasPrism }) {
  return (
    <div className="AmpFaq">
      <AmpAccordion>
        <Fragment>
          <header className="AmpFaq__title" id={pos ? `faq-${pos}` : undefined}>
            {pos ? (
              <h3>
                <span>{pos}</span> {title}
              </h3>
            ) : (
              <h3>{title}</h3>
            )}
          </header>
          <div className="AmpFaq__body">
            {items.map(item => {
              const props = {
                ...item.data,
                isAffiliate,
                hasPrism
              };
              let element = null;
              switch (item.type) {
                case 'html':
                  element = isGiphy(item.data.html) ? null : (
                    <AmpHtml {...props} />
                  );
                  break;
                case 'image':
                  element = <AmpImg {...props} />;
                  break;
                case 'sideBySide':
                  element = <AmpSideBySide {...props} variant="small" />;
                  break;
                case 'video':
                  // Override video placement
                  element = <AmpVideo {...props} placement="faq" />;
                  break;
                default:
                  element = null;
              }
              return (
                <div key={item.id} className="AmpFaq__item">
                  {element}
                </div>
              );
            })}
          </div>
        </Fragment>
      </AmpAccordion>
      <style jsx>{styles}</style>
    </div>
  );
}

AmpFaq.defaultProps = {
  pos: undefined,
  isAffiliate: false,
  hasPrism: false
};

AmpFaq.propTypes = {
  title: string.isRequired,
  items: arrayOf(
    shape({
      type: string,
      data: object
    })
  ).isRequired,
  pos: number,
  isAffiliate: bool,
  hasPrism: bool
};

export default AmpFaq;
